<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" title="요금 수정">
        <v-form lazy-validation ref="form">
          <v-container>
            <v-row align="center">
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">예약자</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span class="ml-1 mb-2">{{driveLogFeeInfo.customerName}}</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">기사이름</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span class="ml-1 mb-2">{{driveLogFeeInfo.driverName}}</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">차량번호</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span class="ml-1 mb-2">{{driveLogFeeInfo.plateNo}}</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">실 결제요금</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span class="ml-1 mb-2">{{driveLogFeeInfo.totalPaidFee}}</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">결제 상황</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span class="ml-1 mb-2">{{driveLogFeeInfo.payStatusName}}</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">주행 요금</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-text-field v-model="driveLogFeeFormData.driveFee" placeholder="주행 요금" :autofocus="true" color="navy" dense maxlength="32"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">대기 요금</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-text-field v-model="driveLogFeeFormData.waitFee" placeholder="대기 요금" :autofocus="true" color="navy" dense maxlength="32"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">도움서비스 요금</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-text-field v-model="driveLogFeeFormData.serviceFee" placeholder="도움서비스 요금" :autofocus="true" color="navy" dense maxlength="32"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">추가 요금</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-text-field v-model="driveLogFeeFormData.extraFee" placeholder="추가 요금" :autofocus="true" color="navy" dense maxlength="32"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">할인 요금 (-)</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-text-field v-model="driveLogFeeFormData.discountFee" placeholder="할인 요금" :autofocus="true" color="navy" dense maxlength="32"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <c-btn class="mr-1 mt-2" color="blue" outlined @click="onUpdateDriveLogFee">수정</c-btn>
              <c-btn class="mt-2" color="gray" outlined @click="openFlag = false">취소</c-btn>
            </v-row>
          </v-container>
        </v-form>
      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: false
      },
      driveLogFeeFormData: {
        type: Object,
        default: undefined
      },
      driveLogFeeInfo: {
        type: Object,
        default: undefined
      }
    },
    data: () => ({
      openFlag: false,
    }),
    watch: {
      open(value) {
        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
    },
    computed: {
    },
    methods: {
      onUpdateDriveLogFee() {
        const formData = new FormData();
        formData.append("id", this.driveLogFeeFormData.driveLogId);
        formData.append("waitFee", this.driveLogFeeFormData.waitFee);
        formData.append("driveFee", this.driveLogFeeFormData.driveFee);
        formData.append("serviceFee", this.driveLogFeeFormData.serviceFee);
        formData.append("extraFee", this.driveLogFeeFormData.extraFee);
        formData.append("discountFee", this.driveLogFeeFormData.discountFee);

        this.$emit('reqUpdateDriveLogFee', formData);
      },
    },
    mounted() {
    }
  }
</script>
